import styled from 'styled-components'
import { SCREEN_SIZE } from '../../lib/Media'

const getColumnWidth = count => {
  return `calc((100% / ${count}) - ((0.75rem * ${count - 1}) / ${count}))`
}

export const PromoCardDefaultWrapper = styled.li`
  margin-bottom: 1.5rem;
  border-radius: 0.25rem;
  overflow: hidden;
  background: white;
  margin-right: 0.75rem;
  width: ${getColumnWidth(6)};

  a {
    text-decoration: none;
    color: #333333;
  }

  &:nth-child(6n) {
    margin-right: 0;
  }

  ${SCREEN_SIZE.Below.Tablet} {
    &:nth-child(n) {
      margin-right: 0.75rem;
      width: ${getColumnWidth(4)};
    }

    &:nth-child(4n) {
      margin-right: 0;
    }

    margin-bottom: 1rem;
  }

  ${SCREEN_SIZE.Below.Mobile} {
    &:nth-child(n) {
      margin-right: 0.75rem;
      width: ${getColumnWidth(2)};
    }

    &:nth-child(2n) {
      margin-right: 0;
    }
  }
`
